import Select, {SelectProps} from '@mui/material/Select';
import NativeSelect, {NativeSelectProps} from '@mui/material/NativeSelect';

import {styled} from '@mui/material/styles';

export const CSelect = styled(Select)<SelectProps>(
  (/* { theme } */) => ({
  }),
);

export const CNativeSelect = styled(NativeSelect)<NativeSelectProps>(
  (/* { theme } */) => ({
  }),
);
